/**
 * @module app.core
 */

import { DynamicViews } from 'app/shared/config/modules';
import { PLATFORM } from 'aurelia-pal';

export function getCoreTaskTypes(): DynamicViews {
    return {
        'Core.Task':
            [],
        'Core.Assessment': [
            {
                title: 'core:taskTypes.assessment.$title',
                url: PLATFORM.moduleName('app/core/components/assessments/tasks/smart-assessment'),
                icon: 'ui:icons.assessment'
            }
        ],
        'Mcg.Assessment': [
            {
                title: 'core:taskTypes.assessment.$title',
                url: PLATFORM.moduleName('app/ext/mcg-informed/smart-assessment'),
                icon: 'ui:icons.assessment'
            }
        ],
        'Core.ContactLog': [
            {
                title: 'core:taskTypes.contactLog.$title',
                url: PLATFORM.moduleName('app/core/components/contact-log/tasks/smart-contact'),
                icon: 'ui:icons.contact.phone'
            }
        ],
        'Core.Document': [
            {
                title: 'core:taskTypes.document.$title',
                url: PLATFORM.moduleName('app/core/components/documents/tasks/smart-document'),
                icon: 'ui:icons.document'
            }
        ],
        'Core.Note': [
            {
                title: 'core:taskTypes.note.$title',
                url: PLATFORM.moduleName('app/core/components/notes/tasks/smart-note'),
                icon: 'ui:icons.note'
            }
        ],
        'Core.CorrespondenceLetter': [
            {
                title: 'core:taskTypes.correspondenceLetter.$title',
                url: PLATFORM.moduleName('app/core/components/correspondence/tasks/smart-correspondence'),
                icon: 'ui:icons.correspondence.general'
            }
        ]
    };
}
